<template>
	<div class="body">
		<el-container>
			
			<el-header>
				<HeaderCus></HeaderCus>
			</el-header>
			
			<el-main>
				<div class="main" style="cursor: pointer;">
					<el-carousel :interval="5000" arrow="always">
						<el-carousel-item v-for="(item, index) in list_banner" :key="index">
							<el-image :src="$common.adimgUrl + item.img" style="width: 1280px; height: 290px;" @click="toUrl(item.url)"></el-image>
							<!-- <el-image :src="item.img"></el-image> -->
						</el-carousel-item>
					</el-carousel>
				</div>
				
				<div class="banner_bottom">
					<div class="main" style="margin-top: 20px;">
						<el-row :gutter="20">
							<el-col :span="6" v-for="(item, index) in list_banner_bottom" :key="index">
								<div class="banner_box" @click="toUrl(item.url)">
									<div class="banner_box_img">
										<el-image :src="$common.adimgUrl + item.icon" fit="contain" style="width: 40px;"></el-image>
									</div>
									<div class="banner_box_title">
										{{item.title}}
									</div>
									<div class="banner_box_summary">
										{{item.summary}}
									</div>
								</div>
							</el-col>
						</el-row>
					</div>
				</div>
				
				<IdxBiaogan :region0_name="list_big_region[0].title" :region0_summary="list_big_region[0].summary" :region0_url="list_big_region[0].url"></IdxBiaogan>
				
				<IdxWendaShuju :region1_name="list_big_region[1].title" :region1_summary="list_big_region[1].summary"
				 :region2_name="list_big_region[2].title" :region2_summary="list_big_region[2].summary"
				 :region1_url="list_big_region[1].url" :region2_url="list_big_region[2].url"></IdxWendaShuju>
				
				<IdxFanganFuwu :region3_name="list_big_region[3].title" :region3_summary="list_big_region[3].summary"
				 :region4_name="list_big_region[4].title" :region4_summary="list_big_region[4].summary"></IdxFanganFuwu>
				
				
			</el-main>
			
			<el-footer>
				<FooterCus></FooterCus>
			</el-footer>
			
		</el-container>
	</div>
</template>

<script>
	import HeaderCus from '../components/header.vue'
	import FooterCus from '../components/footer.vue'
	import IdxBiaogan from '../components/index/idxBiaogan.vue'
	import IdxWendaShuju from '../components/index/idxWendaShuju.vue'
	import IdxFanganFuwu from '../components/index/idxFanganFuwu.vue'
	export default {
		components: {
			HeaderCus,
			FooterCus,
			IdxBiaogan,
			IdxWendaShuju,
			IdxFanganFuwu
		},
		data() {
			return {
				list_banner: [],
				list_banner_bottom: [],
				list_big_region: [{'title': '', 'summary': '', url: ''}, {'title': '', 'summary': '', url: ''}, {'title': '', 'summary': '', url: ''}, {'title': '', 'summary': '', url: ''}, {'title': '', 'summary': '', url: ''}], // 加上默认值，不加js会报错
				
			}
		},
		
		created() {
			this.loadBanner()
			this.loadBannerBottom()
			this.loadBigRegion()
		},
		
		mounted() {
			this.$router.beforeEach((to, from, next) => {
				// console.log(to, from)
				if (to.meta.title) {
					document.title = to.meta.title
				}
				next()
			})
		},
		
		methods: {
			// 加载轮播图
			loadBanner() {
				this.$axios.get(this.$common.apiUrl + 'pub_web_config/detail/10000').then((res) => {
					// let json = JSON.parse(res.data.data.configJson)
					// let json = eval('('+ res.data.data.configJson +')')
					// console.log(json)
					this.list_banner = eval('(' + res.data.data.configJson + ')')
				})
			},
			
			// 加载banner下的4个推荐
			loadBannerBottom() {
				this.$axios.get(this.$common.apiUrl + 'pub_web_config/detail/10001').then((res) => {
					this.list_banner_bottom = eval('(' + res.data.data.configJson + ')')
				})
			},
			
			// 加载大区域标题及描述
			loadBigRegion() {
				this.$axios.get(this.$common.apiUrl + 'pub_web_config/detail/10013').then((res) => {
					// console.log(res.data.data.configJson)
					this.list_big_region = eval('(' + res.data.data.configJson + ')')
				})
			},
			
			// web配置数据链接跳转
			toUrl(url) {
				// console.log(url)
				if (url.indexOf('http') > -1) {
					location.href = url
				} else {
					this.$router.push({path: url})
				}
			},
			
			
		}
	}
</script>

<style scoped>
/deep/ .el-carousel__button {
	background-color: #fff !important;
	opacity: .5 !important;
	width: 40px !important;
	height: 5px !important;
}
/deep/ .el-carousel__indicator.is-active button {
	background-color: #f60 !important;
	opacity: 1 !important;
}
</style>